import React from 'react';
import OdfjellInputComponent, { InputChangeData } from 'src/components/common/odfjell-input-component/OdfjellInputComponent';
import { EngineDataTypeEnum } from 'src/types/ViewModel/AolEnums';
import { Bunkering } from 'src/types/ViewModel/Bunkering/Bunkering';
import { AddConsumptionWrapper } from './Consumption.style';
import { Consumption } from 'src/types/ViewModel/Aol/Consumption';
import Tooltip from 'src/components/ui/tooltip/Tooltip';
import { getTanksWhereBunkerRefHasROB } from 'src/components/bunkering/bunker-rob-page/RobUtils';
import { FuelROB } from 'src/types/ViewModel/Bunkering/FuelROB';

interface Props {
    noonReportId: number;
    engineDataType: EngineDataTypeEnum;
    bunkerings: Bunkering[];
    consumption: Consumption[];
    addConsumptionRow: (consumption: Consumption[]) => void;
    fuelRobData: FuelROB[];
}

const AddConsumptionRow: React.FC<Props> = ({ noonReportId, engineDataType, bunkerings, consumption, addConsumptionRow, fuelRobData }) => {
    const handleSelect = (input: InputChangeData) => {
        if (input.event.target.value && input.event.target.value === 'Select fuel') return;
        const selectedBunkering = bunkerings.find((b) => b.bunkeringReference === input.event.target.value);

        const tanks = getTanksWhereBunkerRefHasROB(selectedBunkering.bunkeringGuid, fuelRobData, bunkerings);

        const consumption = tanks.map((t) => {
            return {
                consumptionId: 0,
                noonReportId: noonReportId,
                bunkeringId: selectedBunkering?.bunkeringId,
                bunkeringGuid: selectedBunkering?.bunkeringGuid,
                engineDataType: engineDataType,
                fuelType: selectedBunkering?.fuelType,
                tankId: t,
                consumptionMt: 0,
            } as Consumption;
        });

        addConsumptionRow(consumption);
    };

    const getSelectorText = () => {
        const allOptions = bunkerings?.map((b) => b.bunkeringReference);
        const availableOptions = bunkerings
            ?.filter((b) => !consumption?.find((c) => c.bunkeringGuid === b.bunkeringGuid))
            .map((b) => b.bunkeringReference);
        if (availableOptions && availableOptions.length > 0) return 'Add fuel consumption';
        if (allOptions && allOptions.length > 0) return 'All available selected';
        return (
            <Tooltip type="warning" text="At least one bunkering must be registered and available for use in the Bunker page">
                No fuel available
            </Tooltip>
        );
    };

    return (
        <AddConsumptionWrapper>
            <OdfjellInputComponent
                type={'select'}
                options={bunkerings?.filter((b) => !consumption?.find((c) => c.bunkeringGuid === b.bunkeringGuid)).map((b) => b.bunkeringReference)}
                name="Bunkering"
                value={getSelectorText()}
                isReadOnly={bunkerings?.filter((b) => !consumption?.find((c) => c.bunkeringGuid === b.bunkeringGuid))?.length === 0}
                selectDefaultOption={'Add fuel consumption'}
                onChange={handleSelect}
            />
        </AddConsumptionWrapper>
    );
};

export default AddConsumptionRow;
